module.exports = __webpack_public_path__ + "static/media/oppidum.c4dc118e.jpg";